import CustomPdfInput from "components/CustomPdfInput";
import { useEffect } from "react";
import { useDataProvider } from "react-admin";
import { useField } from "react-final-form";
import { isValidUrl } from "../tools";

interface IPdfInputField {
  id: string;
  uploadProgress: number;
}

const CcaEventPdfInput = ({ uploadProgress, id }: IPdfInputField) => {
  const provider = useDataProvider();
  const ccaEventPdfUrlField = useField("ccaEventPdfUrl");

  useEffect(() => {
    if (
        ccaEventPdfUrlField.input.value &&
      !isValidUrl(ccaEventPdfUrlField.input.value)
    ) {
      provider.customGetOne(`schools/${id}`).then(({ data }: any) => {
        ccaEventPdfUrlField.input.onChange(data.ccaEventPdfUrl);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ccaEventPdfUrlField.input.value]);

  return (
    <CustomPdfInput
      label="CCA Event (PDF)"
      source="ccaEventPdfFile"
      urlSource="ccaEventPdfUrl"
      uploadProgress={uploadProgress}
      maxSize={15000000}
    />
  );
};

export default CcaEventPdfInput;
